import ServicePage from "./page";
import { lifeInsuranceData } from "@/mocks/insurancePages";

export default function LifeInsurance() {
  return <ServicePage data={lifeInsuranceData} />;
}